import React from 'react';
import './Checkbox.css';

function Checkbox({selected, onClick}) {
    const handleClick = () => {
        if (onClick) onClick(!selected);
    };

    const checkboxStyle = () => {
        return {
            backgroundColor: selected ? '#002DFF' : '#FFFFFF'
        };
    };

    return (
        <div className='checkbox_outline' onClick={handleClick}>
            <div className='checkbox' style={checkboxStyle()}>
            </div>
        </div>
    );
}

export default Checkbox;